// Mirrors FleetHd.Issue MetricSnapshotDto. The confidence and severity history of
// one Issue.
//
// Two kinds of row share the shape. A discrete row (contribution_added,
// state_transition) is one real sample: the value and the moment it was taken.
// An aging_summary row is a rolling aggregate of consecutive aging passes, so the
// array grows per episode rather than per pass: confidence and capturedAt carry
// the END of the run, confidenceStart and firstCapturedAt carry the start,
// confidenceMin and confidenceMax carry the envelope in between, and sampleCount
// says how many passes folded into it. The next discrete row closes the run.
//
// aging_threshold_crossed is the older per-pass row. Issues written before the
// summary exists still carry them, and they have none of the five summary fields,
// so read a row as a single sample unless its trigger says aging_summary.

export const SnapshotTriggers = {
  ContributionAdded: 'contribution_added',
  StateTransition: 'state_transition',
  AgingThresholdCrossed: 'aging_threshold_crossed',
  AgingSummary: 'aging_summary',
} as const;
export type SnapshotTrigger = typeof SnapshotTriggers[keyof typeof SnapshotTriggers];

export interface MetricSnapshotDto {
  capturedAt: string;
  confidence: number;
  severity: number;
  lifecycleState: string;
  trigger: string;
  contributionsCount: number;
  confidenceStart: number;
  confidenceMin: number;
  confidenceMax: number;
  sampleCount: number;
  firstCapturedAt: string;
}
